import { render } from "./DatabaseOverview.vue?vue&type=template&id=20ce66fa"
import script from "./DatabaseOverview.vue?vue&type=script&lang=js"
export * from "./DatabaseOverview.vue?vue&type=script&lang=js"

import "./DatabaseOverview.vue?vue&type=style&index=0&id=20ce66fa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__